import { type PartialDeep } from 'type-fest';

import {
  type RequestFormFilterKeys,
  type RequestFormFilters,
} from '@entities/merchant';

const FILTER_KEYS: RequestFormFilterKeys[] = [
  'marketplace_statuses',
  'marketplace_priorities',
  'marketplace_last_imported_at',
  'marketplace_status_changed_at',
  'marketplace_tags',
  'marketplace_decisions',
  'scan_results',
  'critical_results',
];

const isMarketplacesFiltersActive = (
  initial: RequestFormFilters,
  filter?: PartialDeep<RequestFormFilters>,
) => {
  if (!filter) return false;

  return FILTER_KEYS.some(
    (key) => JSON.stringify(filter[key]) !== JSON.stringify(initial[key]),
  );
};

export default isMarketplacesFiltersActive;
